// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TeSU+","label":"styles_label__Hyu4n"};